const projects = [
  {
    id: 1,
    country: "Iraq",
    location: "Baghdad",
    name: "Tekrit Health District Hospitals",
    scope: "ICU Setup & Equipment Supply",
    year: "2023",
    img: "https://public.readdy.ai/ai/img_res/a36a6c37b4dcc1a9d99b59dafec93502.jpg",
    size: "lg",
  },
  {
    id: 2,
    country: "Syria",
    location: "Damascus",
    name: "North Syria Private Hospitals",
    scope: "Full Hospital Turnkey Project",
    year: "2022",
    img: "https://readdy.ai/api/search-image?query=hospital%20interior%20renovation%20project%20completed%20modern%20ICU%20ward%20with%20new%20medical%20equipment%2C%20clean%20white%20walls%20and%20professional%20lighting%2C%20healthcare%20facility%20upgrade%20photography%2C%20intensive%20care%20unit%20setup&width=600&height=400&seq=proj002&orientation=landscape",
    size: "sm",
  },
  {
    id: 3,
    country: "Lebanon",
    location: "Beirut",
    name: "Palestine Red Cross Hospitals",
    scope: "Radiology Department Setup",
    year: "2022",
    img: "https://readdy.ai/api/search-image?query=modern%20hospital%20radiology%20department%20with%20X-ray%20and%20imaging%20equipment%2C%20clean%20clinical%20room%20with%20white%20walls%20and%20professional%20lighting%2C%20medical%20imaging%20center%20interior%2C%20healthcare%20facility%20photography&width=600&height=400&seq=proj003&orientation=landscape",
    size: "sm",
  },
  {
    id: 4,
    country: "India",
    location: "New Delhi",
    name: "Fortis Healthcare Group",
    scope: "ICU & Operating Theater Equipment",
    year: "2021",
    img: "https://readdy.ai/api/search-image?query=modern%20private%20hospital%20building%20in%20India%20city%2C%20contemporary%20healthcare%20facility%20exterior%20architecture%2C%20large%20hospital%20complex%20with%20green%20landscape%2C%20professional%20medical%20center%20photography%2C%20premium%20hospital&width=600&height=400&seq=proj004&orientation=landscape",
    size: "sm",
  },
  {
    id: 5,
    country: "Palestine",
    location: "Gaza",
    name: "Palestine Red Cross Hospitals",
    scope: "Emergency & Critical Care Equipment",
    year: "2021",
    img: "https://readdy.ai/api/search-image?query=hospital%20emergency%20department%20equipped%20with%20modern%20medical%20devices%20monitors%20and%20equipment%2C%20professional%20emergency%20room%20setup%2C%20clean%20clinical%20setting%20with%20proper%20lighting%2C%20healthcare%20facility%20interior%20photography&width=600&height=400&seq=proj005&orientation=landscape",
    size: "sm",
  },
  {
    id: 6,
    country: "Libya",
    location: "Tripoli",
    name: "Tripoli Medical Center",
    scope: "Hospital Furniture & Stainless Equipment",
    year: "2020",
    img: "https://readdy.ai/api/search-image?query=modern%20hospital%20ward%20interior%20with%20new%20hospital%20furniture%20beds%20and%20stainless%20steel%20medical%20equipment%2C%20clean%20clinical%20room%20with%20professional%20lighting%2C%20healthcare%20facility%20upgrade%20renovation%20photography&width=600&height=400&seq=proj006&orientation=landscape",
    size: "lg",
  },
];

const flags: Record<string, string> = {
  Iraq: "🇮🇶",
  Syria: "🇸🇾",
  Lebanon: "🇱🇧",
  India: "🇮🇳",
  Palestine: "🇵🇸",
  Libya: "🇱🇾",
};

export default function Projects() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-amber-500 mb-3">Our Work</span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
              Successful Hospital
              <span className="block text-amber-500">Transformations</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-md">
            Delivering healthcare infrastructure excellence across Iraq, Syria, Lebanon, India, Palestine, Libya, and beyond.
          </p>
        </div>

        {/* Countries Badge Row */}
        <div className="flex flex-wrap gap-3 mb-10">
          {Object.entries(flags).map(([country, flag]) => (
            <span key={country} className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gray-100 text-sm text-gray-700 font-medium">
              <span>{flag}</span> {country}
            </span>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Row 1: Large + 2 Small */}
          <div
            className="md:col-span-1 rounded-2xl overflow-hidden relative group cursor-pointer"
            onClick={scrollToContact}
          >
            <img
              src={projects[0].img}
              alt={projects[0].name}
              className="w-full h-[340px] object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            {/* Hover overlay CTA */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20">
              <span className="flex items-center gap-2 px-5 py-2.5 bg-amber-500 text-white text-sm font-semibold rounded-full shadow-lg whitespace-nowrap">
                <i className="ri-mail-send-line"></i> Get a Quote
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-block px-3 py-1 rounded-full text-xs bg-amber-500 text-white mb-2 font-semibold">
                {flags[projects[0].country]} {projects[0].country}
              </span>
              <h3 className="text-white font-bold text-lg">{projects[0].name}</h3>
              <p className="text-gray-300 text-sm mt-1">{projects[0].scope}</p>
              <p className="text-amber-400 text-xs mt-1 font-medium">{projects[0].year}</p>
            </div>
          </div>

          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {projects.slice(1, 5).map((p) => (
              <div
                key={p.id}
                className="rounded-2xl overflow-hidden relative group cursor-pointer"
                onClick={scrollToContact}
              >
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                {/* Hover overlay CTA */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20">
                  <span className="flex items-center gap-2 px-4 py-2 bg-amber-500 text-white text-xs font-semibold rounded-full shadow-lg whitespace-nowrap">
                    <i className="ri-mail-send-line"></i> Get a Quote
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs bg-amber-500 text-white mb-1.5 font-semibold">
                    {flags[p.country]} {p.country}
                  </span>
                  <h3 className="text-white font-bold text-sm">{p.name}</h3>
                  <p className="text-gray-300 text-xs mt-0.5">{p.scope}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2: Wide Card */}
          <div
            className="md:col-span-3 rounded-2xl overflow-hidden relative group cursor-pointer"
            onClick={scrollToContact}
          >
            <img
              src={projects[5].img}
              alt={projects[5].name}
              className="w-full h-56 object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-transparent"></div>
            {/* Hover overlay CTA */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/10">
              <span className="flex items-center gap-2 px-5 py-2.5 bg-amber-500 text-white text-sm font-semibold rounded-full shadow-lg whitespace-nowrap">
                <i className="ri-mail-send-line"></i> Get a Quote
              </span>
            </div>
            <div className="absolute left-0 top-0 bottom-0 p-8 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 rounded-full text-xs bg-amber-500 text-white mb-2 font-semibold w-fit">
                {flags[projects[5].country]} {projects[5].country}
              </span>
              <h3 className="text-white font-bold text-xl">{projects[5].name}</h3>
              <p className="text-gray-300 text-sm mt-1">{projects[5].scope}</p>
              <p className="text-amber-400 text-xs mt-2 font-medium">{projects[5].year}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
